import * as z from 'zod';

import { paymentStatusOptions } from '@/_pages/agreements/shared/installments/helpers';
import { paymentStatus } from '@/_pages/agreements/shared/installments/schemas/agreement-installments-query-schema';
import { paymentMethodQueryLinkerSchema } from '@/_pages/settings/payment-methods/shared/schemas/payment-method-query-linker-schema';
import { currencyInput } from '@/_schemas/generic';

export const invoicePaymentLineFormSchema = z.object({
  agreement_payment_id: z.number().nullable(),
  contact_id: z.number().nullable(),
  amount: currencyInput.formSchemaWithValidation(0),
  payment_date: z.string().refine((val) => !!val?.trim(), { error: 'Payment date is required' }),
  payment_method: paymentMethodQueryLinkerSchema.nullable().refine((v) => v != null && v.id > 0, {
    error: 'Payment method is required',
  }),
  payment_status: z.object({ name: z.string(), value: paymentStatus }),
});

export type InvoicePaymentLineFormSchema = z.infer<typeof invoicePaymentLineFormSchema>;

export function defaultInvoicePaymentLineFormValues(): InvoicePaymentLineFormSchema {
  return {
    agreement_payment_id: null,
    contact_id: null,
    amount: currencyInput.defaultValue(),
    payment_date: new Date().toISOString().slice(0, 10),
    payment_method: null,
    payment_status: paymentStatusOptions[0],
  };
}
